
    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"chart-date-range-filter"},[_c('button',{ref:"badge",staticClass:"date-range-badge",attrs:{"type":"button"},on:{"click":toggle}},[_c('span',{staticClass:"date-range-badge-icon"}),_c('span',{staticClass:"date-range-badge-label"},[_v("Date Range")])]),_c('input',{ref:"input",staticClass:"date-range-input",attrs:{"readonly":"readonly","type":"text"}})])}},
      staticRenderFns: []
    };
  